"use strict";Object.defineProperty(exports, "__esModule", {value: true});function t(n){return!!(n&&{}.toString.call(n)==="[object Function]")}var i=t;exports.a = i;
